import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderSl = () => {
    return (
        <HighlightedText
            text="ČESTITKE!"
            highlights={[{ word: 'ČESTITKE!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentSl = () => {
    return (
        <HighlightedText
            text="OSVOJILI STE 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[
                { word: '400' },
                { word: 'BREZPLAČNIH' },
                { word: 'VRTLJAJEV' },
            ]}
            breakAfterWords={['STE', 'BREZPLAČNIH']}
            className={styles['text_content--SECOND']}
        />
    )
}
